module.exports = __webpack_public_path__ + "static/media/tooMuchHair2009.c71da4d8.jpg";